import ko from '@/internationalization/trans/chefs/ko/ko.json';
export default {
  trans: ko,
};
